import { Component, computed, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FileTableComponent, BreadcrumbListComponent } from '@r1-compass-library/components';
import { LifecycleRulesetListStore } from '../store/lifecycle-ruleset-list.store';
import { AppConstants } from '../../app.constants';
import { MatButtonModule } from '@angular/material/button';
import { LifecycleRulesetFolderService, LifecycleRulesetService } from '@r1-compass-library/services';
import { AssetListComponent } from '../../asset-list.component';
import { LifecycleRuleset } from '@r1-compass-library/models/lifecycle-rules/lifecycle-ruleset.model';
import { FileTableEntry } from '@r1-compass-library/components/file-table/file-table.model';

@Component({
    selector: 'r1-compass-app-lifecycle-rules-list',
    imports: [BreadcrumbListComponent, FileTableComponent, MatButtonModule, MatMenuModule],
    templateUrl: './lifecycle-rules-list.component.html',
    styleUrl: './lifecycle-rules-list.component.scss',
})
export class LifecycleRulesListComponent extends AssetListComponent<
    LifecycleRuleset,
    LifecycleRulesetService,
    LifecycleRulesetFolderService,
    LifecycleRulesetListStore
> {
    override EDIT_ASSET_PATH: string = AppConstants.LifecycleRulesDefinitionComponent.path;
    override BASE_PATH = '/lifecycle-rules';
    override columns = AppConstants.folderNameColumnsForAssets;

    constructor() {
        super(
            inject(LifecycleRulesetListStore),
            inject(LifecycleRulesetService),
            inject(LifecycleRulesetFolderService)
        );
    }

    override sortedFileTableEntries = computed<FileTableEntry[]>(() =>
        this.assetListSortingService.defaultSortWithEnabled(this.vm().contentWithActions)
    );
}
